// extracted by mini-css-extract-plugin
export default {"frameGradient":"Toggle_Button_frameGradient__AI94v","root":"Toggle_Button_root__Hp+-i","horizontal":"Toggle_Button_horizontal__P4hir"};